// src/services/instances/standing.ts
//
// Cliente HTTP para Standings (tabela de classificação por fase).

import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';

import {
  GetStandingByIdResponse,
  GetStandingsResponse,
  GetStandingsSummaryResponse,
  PostStandingResponse,
  PostStandingsBatchResponse,
  PutStandingResponse,
  PutStandingsOrderResponse,
} from '../response/standing';

import {
  PostStandingRequest,
  PostStandingsBatchRequest,
  PutStandingRequest,
  PutStandingsOrderRequest,
} from '../request/standing';

export class StandingService {
  /** GET /stages/:id/standings — lista paginada. */
  static getStandings(id: string, params?: QueryParams) {
    return apiClient.get<GetStandingsResponse>(buildApiUrl('/api/v1/competitions/stages/:id/standings', { id }), params);
  }

  /** GET /stages/:id/standings/summary — top N (default 6, max 100). */
  static getStandingsSummary(id: string, params?: QueryParams) {
    return apiClient.get<GetStandingsSummaryResponse>(
      buildApiUrl('/api/v1/competitions/stages/:id/standings/summary', { id }),
      params,
    );
  }

  /** GET /standings/:id — detalhe de uma standing. */
  static getStandingById(id: string) {
    return apiClient.get<GetStandingByIdResponse>(buildApiUrl('/api/v1/competitions/standings/:id', { id }));
  }

  /** POST /stages/:id/standings — upsert de uma standing. */
  static postStanding(id: string, data: PostStandingRequest) {
    return apiClient.post<PostStandingResponse>(buildApiUrl('/api/v1/competitions/stages/:id/standings', { id }), data);
  }

  /** POST /stages/:id/standings/batch — upsert de várias. */
  static postStandingsBatch(id: string, data: PostStandingsBatchRequest) {
    return apiClient.post<PostStandingsBatchResponse>(
      buildApiUrl('/api/v1/competitions/stages/:id/standings/batch', { id }),
      data,
    );
  }

  /** PUT /standings/:id — atualiza estatísticas de uma standing. */
  static putStanding(id: string, data: PutStandingRequest) {
    return apiClient.update<PutStandingResponse>(buildApiUrl('/api/v1/competitions/standings/:id', { id }), data);
  }

  /** PUT /stages/:id/standings/order — reordena posições. */
  static putStandingsOrder(id: string, data: PutStandingsOrderRequest) {
    return apiClient.update<PutStandingsOrderResponse>(
      buildApiUrl('/api/v1/competitions/stages/:id/standings/order', { id }),
      data,
    );
  }

  /** DELETE /standings/:id — remove uma standing. */
  static deleteStanding(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/standings/:id', { id }));
  }
}
